var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.isEmployee)?_c('EmployeeForm'):_c('CustomerForm')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }